import { createContext } from 'react';

export type ReviewDetailsContextType = {
  mode: 'guest' | 'authorized';
};

export const ReviewDetailsContext = createContext<ReviewDetailsContextType>({
  mode: 'guest',
});
